import axios from 'axios';

export default {
  findAdminTerms: (data) => {
    return axios.put('/api/admin/terms', data)
      .then(response => ({
        terms: response.data.terms ?? [],
      }));
  },

  getAdminTerm: (payload) => {
    return axios.get(`/api/admin/terms/${payload.entityId}`)
      .then(response => ({
        term: response.data.term ?? {},
      }));
  },

  saveAdminTerm: (payload) => {
    return axios.put(`/api/admin/terms/${payload.entityId}`, payload)
      .then(response => ({
        term: response.data.term ?? {},
      }));
  },
};
